
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/swap/[[...slug]]",
      function () {
        return require("private-next-pages/swap/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/swap/[[...slug]]"])
      });
    }
  